import React, { useMemo, useState, useRef, useEffect } from "react";
import { Box, Button, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { useTranslation } from "react-i18next";
import { useEditMessageCodeMutation } from "../../../middleware/messageCodeApi";
import CheckboxSimple from "../../components/CheckboxSimple";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { TooltipProps } from "../../../helpers/materialUITheme";

import { SelectMultipleChipDeletableWithSearchField } from "../../components/SelectMultipleChipDeletableWithSearchField";
import { useGetFacFireCompSelectElementsQuery } from "../../../middleware/facilitiesApi";
import { dateFormat, dateFormatWithTimeWithoutA } from "../../../constants";
import dayjs from "dayjs";
export const ControllerStatusCell = ({ item }) => {
  const { t } = useTranslation();
  const status = useMemo(() => (item ? "connectedController" : "disconnectedController"), [item]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Tooltip title={t(`label:controllerStatusTooltips:${status}`)} componentsProps={TooltipProps}>
        <CircleIcon sx={{ color: `var(--${status})` }} />
      </Tooltip>
    </Box>
  );
};
export const InputTextCustom = ({ item }) => {
  const { id, value } = item;
  const inputRef = useRef(null);
  const [editMessageCode, { error: errorEdit, isSuccess: isSuccessEdit }] = useEditMessageCodeMutation();
  const [isEditing, setisEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  useEffect(() => {
    setEditValue(value);
  }, [value]);
  const handleStartEdit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setisEditing(true);
    // setEditValue(value);
  };
  const handleCancelEdit = () => {
    setisEditing(false);
  };

  const handleSaveEdit = (e) => {
    e?.stopPropagation();
    editMessageCode({ controlConsoleId: id, controlConsoleName: editValue, updateControlConsoleSettings: true }).then(
      ({ data, error }) => {
        if (error) return;
        handleCancelEdit();
      }
    );
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSaveEdit(e);
    }
    if (e.key === "Escape") {
      handleCancelEdit();
    }
  };

  return (
    <Box display={"flex"} justifyContent={"space-between"}>
      {isEditing ? (
        <TextField
          fullWidth
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={(e) => handleKeyDown(item, e)}
          inputRef={isEditing ? inputRef : null}
          autoFocus
          sx={{ mr: 2 }}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <Tooltip title={editValue} componentsProps={TooltipProps} placement="right" arrow>
          <Typography
            sx={{
              fontWeight: 600,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word",
              lineHeight: `24px`,
              maxHeight: 46,
              padding: "8px 0",
            }}
          >
            {editValue}
          </Typography>
        </Tooltip>
      )}

      {!isEditing && (
        <IconButton
          className="edit-button"
          onClick={(e) => handleStartEdit(e)}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      )}
      {isEditing && (
        <>
          <IconButton onClick={(e) => handleSaveEdit(e)} color="primary" onMouseDown={(e) => e.stopPropagation()}>
            <CheckIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={handleCancelEdit} color="error" onMouseDown={(e) => e.stopPropagation()}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      )}
    </Box>
  );
};
export const DiagnosticsCell = ({ item }) => {
  const { id, value } = item;

  const [editMessageCode, { error: errorEdit, isSuccess: isSuccessEdit }] = useEditMessageCodeMutation();
  const [checkvalue, setcheckValue] = useState(value);
  const handleChangeDiagnosticsStatus = (e) => {
    editMessageCode({
      controlConsoleId: id,
      hasDiagnostics: e.target.checked,
      updateControlConsoleSettings: true,
    }).then(({ data, error }) => {
      if (error) return;
    });
    setcheckValue(e.target.checked);
  };
  
  return (
    <Box sx={{ width: "100%", textAlign: "center", ml: "11px" }}>
      <CheckboxSimple value={checkvalue} onChange={handleChangeDiagnosticsStatus} />
    </Box>
  );
};
export const ClickableActionNameCell = ({ item }) => {
  const { name, action } = item || {};
  return (
    <Tooltip title={name} componentsProps={TooltipProps}>
      <Typography
        sx={{ color: "var(--accent)" }}
        className={name ? "table-row-cell-link" : ""}
        onClick={action ? action : () => {}}
      >
        {name || ""}
      </Typography>
    </Tooltip>
  );
};

export const ClickableActionListCell = ({ item }) => {
  if (!item) {
    return null;
  }

  const maxVisibleItems = 3;
  const shouldShowToggle = item.facilities.length > maxVisibleItems;
  const visibleItems = item.facilities.slice(0, maxVisibleItems);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ maxHeight: `${3 * 1.5}em`, overflow: "hidden" }}>
        {visibleItems.map((element, index) => (
          <ClickableActionNameCell key={index} item={element} />
        ))}
      </div>

      {shouldShowToggle && (
        <Typography
          onClick={item.actionShowMore}
          sx={{
            alignSelf: "flex-start",
            color: "black",
            cursor: "pointer",
            padding: "4px 0",
            marginTop: "4px",
          }}
        >
          Показать все ({item.facilities.length})
        </Typography>
      )}
    </div>
  );
};
export const BelongsToConsoleCell = ({ item }) => {
  const { t } = useTranslation();
  const { isBelongsToConsole, action } = item;

  const objectStatusLabel = isBelongsToConsole ? "controller_disable_object" : "controller_enable_object";
  const objectStatusClass = isBelongsToConsole ? "btn btn-remove" : "btn btn-primary-fill";

  return (
    <Button className={objectStatusClass} sx={{ width: "133px" }} onClick={action}>
      {t(`button:${objectStatusLabel}`)}
    </Button>
  );
};

export const SimpleHeader = ({ name }) => (
  <Box className="table-head-up_level">
    <Typography className="standart">{name || ""}</Typography>
  </Box>
);
export const ObjectsSelect = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const { data: facFireCompSelect = [] } = useGetFacFireCompSelectElementsQuery(searchValue);

  return (
    <SelectMultipleChipDeletableWithSearchField
      setSearchValue={setSearchValue}
      isIds={true}
      searchValue={searchValue}
      options={facFireCompSelect}
      {...props}
    />
  );
};
export const SimpleTextCell = ({ item, type, withTooltip = false }) => {
  const content =
    type === "date"
      ? dayjs(item).format(dateFormat)
      : type === "dateTime"
        ? dayjs(item).format(dateFormatWithTimeWithoutA)
        : item;

  return (
    <>
      {withTooltip ? (
        <Tooltip title={content || ""} componentsProps={TooltipProps} placement="right" arrow>
          <Typography className="common-cell-text">{content || ""}</Typography>
        </Tooltip>
      ) : (
        <Typography className="common-cell-text">{content || ""}</Typography>
      )}
    </>
  );
};
export const ClickableNameCell = ({ item, withTooltip = false }) => {
  const { name, action } = item || {};
  return (
    <>
      {withTooltip ? (
        <Typography className="table-row-cell-link" onClick={action ? action : () => {}}>
          {name || ""}
        </Typography>
      ) : (
        <Tooltip title={name || ""} componentsProps={TooltipProps}>
          <Typography className="table-row-cell-link" onClick={action ? action : () => {}}>
            {name || ""}
          </Typography>
        </Tooltip>
      )}
    </>
  );
};
